import { PromisePool, ProcessHandler } from '@supercharge/promise-pool';

export const runWorkInBatches = async <T, Y>(
  data: Array<T>,
  callBack: ProcessHandler<T, Y>,
  concurrency = 10
) => {
  return PromisePool.for(data).withConcurrency(concurrency).process(callBack);
};
